import type { BetterFeatureClientPlugin } from "@di-devs/better-feature/types";
import type { audience } from "../server/plugin";
import { createAudienceManagementPlugin } from "./audience-core/plugin";

export const audienceClient = () => {
	return {
		id: "audience",
		$InferServerPlugin: {} as ReturnType<typeof audience>,
		getAtoms: ($fetch: any) => {
			// Create subfeature plugins
			const audienceManagementPlugin = createAudienceManagementPlugin($fetch);

			return {
				// Signals (prefixed with $)
				$listAudiencesSignal:
					audienceManagementPlugin.signals.$listAudiencesSignal,
				$searchAudienceSignal:
					audienceManagementPlugin.signals.$searchAudienceSignal,
				$createAudienceSignal:
					audienceManagementPlugin.signals.$createAudienceSignal,
				$deleteAudienceSignal:
					audienceManagementPlugin.signals.$deleteAudienceSignal,

				// Queries (become hooks with "use" prefix)
				listAudiences: audienceManagementPlugin.queries.listAudiences,
				searchAudience: audienceManagementPlugin.queries.searchAudience,
				createAudience: audienceManagementPlugin.queries.createAudience,
				deleteAudience: audienceManagementPlugin.queries.deleteAudience,

				// State atoms
				...audienceManagementPlugin.atoms,
			};
		},
		getActions: ($fetch: any) => {
			const audienceManagementPlugin = createAudienceManagementPlugin($fetch);

			return {
				// Actions are spread directly onto client
				...audienceManagementPlugin.actions,
			};
		},
		atomListeners: [
			{
				signal: "$sessionSignal",
				matcher: (path: string) => path.startsWith("/audiences"),
			},
		],
	} satisfies BetterFeatureClientPlugin;
};
